import Styles from './story.module.css';
import HubShot from './../../../image/landing/story/hub-input.png';
// AXIS 02（業界ネットワーク図）は一旦非表示。復活時に import を戻す。
// import NetworkDiagram from './../_ui/networkDiagram';
import {
  IoDocumentTextOutline, IoMailOutline, IoSendOutline, IoGridOutline,
  IoFileTrayStackedOutline, IoPhonePortraitOutline,
} from "react-icons/io5";

/* ============================================================
   AXIS 01 : サロンの実利
     「散らばった求人票業務 → プロダクトで集約 → 整った学校ネットワーク」を
     1枚のストーリービジュアルで見せる（比較表にしない）
   AXIS 02 : 業界全体の仕組み（広く・大胆に / 大型ネットワーク図）
   ============================================================ */

const scattered = [
  { icon: <IoDocumentTextOutline />, label: '学校AへPDF', cls: 'p1' },
  { icon: <IoMailOutline />, label: '学校Bへ郵送', cls: 'p2' },
  { icon: <IoSendOutline />, label: '学校Cへメール', cls: 'p3' },
  { icon: <IoGridOutline />, label: '学校Dへ別フォーマット', cls: 'p4' },
  { icon: <IoFileTrayStackedOutline />, label: '送付先を個別管理', cls: 'p5' },
];

const Story = () => {
  return (
    <div className={Styles.block}>

      {/* ---------- AXIS 01 : 散らばり → 集約 → 展開 ---------- */}
      <div className={Styles.axis1}>
        <div className={Styles.head}>
          <span className={Styles.kicker}>サロンにとって</span>
          <h2>学校ごとに送っていた求人票を、<br className={Styles.brsp} />1回の登録に。</h2>
          <p className={Styles.sub}>
            紹介したい学校ごとに求人票を作って送っていた作業を、1回の入力と送付先の選択にまとめます。
          </p>
        </div>

        <div className={Styles.flow}>
          {/* これまで：雑然と散らばったタスク */}
          <div className={Styles.stage}>
            <span className={Styles.phaseTag}>これまで</span>
            <div className={Styles.scatter}>
              {scattered.map((s) => (
                <span key={s.cls} className={`${Styles.task} ${Styles[s.cls]}`}>
                  {s.icon}{s.label}
                </span>
              ))}
            </div>
            <p className={Styles.stageNote}>学校ごとに、作り方も送り方もバラバラ</p>
          </div>

          <span className={Styles.arrow} aria-hidden="true">›</span>

          {/* memorii works：実プロダクトが受け止める */}
          <div className={`${Styles.stage} ${Styles.stageHub}`}>
            <span className={`${Styles.phaseTag} ${Styles.phaseTagHub}`}>memorii works</span>
            <div className={Styles.screen}>
              <div className={Styles.screenBar}><i /><i /><i /></div>
              <div className={`${Styles.screenBody} ${Styles.screenBodyImg}`}>
                <img src={HubShot} alt="求人情報の入力・送付先選択画面" />
              </div>
            </div>
            <p className={Styles.hubCaption}>求人情報を1回入力し、<br className={Styles.brsp} />送りたい学校を選ぶだけ</p>
          </div>

          <span className={`${Styles.arrow} ${Styles.arrowStrong}`} aria-hidden="true">›</span>

          {/* これから：整った学校ネットワーク */}
          <div className={Styles.stage}>
            <span className={`${Styles.phaseTag} ${Styles.phaseTagAfter}`}>これから</span>
            <div className={Styles.fan}>
              <svg viewBox="0 0 220 200" className={Styles.fanSvg} role="img"
                aria-label="1回の登録から、学校A・B・C・Dへ整理された流れで届く">
                <path d="M8 100 C 78 100, 96 34, 150 34" />
                <path d="M8 100 C 78 100, 96 78, 150 78" />
                <path d="M8 100 C 78 100, 96 122, 150 122" />
                <path d="M8 100 C 78 100, 96 166, 150 166" />
                <circle className={Styles.fanOrigin} cx="8" cy="100" r="6" />
                <circle cx="150" cy="34" r="5" />
                <circle cx="150" cy="78" r="5" />
                <circle cx="150" cy="122" r="5" />
                <circle cx="150" cy="166" r="5" />
                <text x="164" y="38">学校A</text>
                <text x="164" y="82">学校B</text>
                <text x="164" y="126">学校C</text>
                <text x="164" y="170">学校D</text>
              </svg>
            </div>
            <p className={Styles.stageNote}>選んだ学校すべてに、まとめて提出</p>
          </div>
        </div>

        <p className={Styles.appHint}>
          <IoPhonePortraitOutline aria-hidden="true" />
          導入校では、そのまま学生アプリの掲載にもつながります
        </p>
      </div>

      {/*
        一旦非表示（後で使うかもしれないので実装は残置）:
        ・接続コピー「求人票を送る手間を減らす。／でも、memorii works が変えたいのは、その先です。」
        ・AXIS 02「美容業界にとって／学校ごとに分かれていた求人情報を、美容業界でつながる仕組みへ。」＋
          業界ネットワーク図（従来 vs memorii works）＋「求人票が、学校で止まらない業界へ。」
        CSS: story.module.css の .connector* / .axis2 / .headVision / .diagramWrap / .vision
        図:  ./../_ui/networkDiagram（コンポーネントは残置）
        復活する場合はこのコメント位置に JSX と import を戻す。
      */}
    </div>
  );
};

export default Story;
